<ng-container *ngIf="paymentMethodsOnly; else fullPageSkeleton">
  <div class="payment-wallet order-payment-com-page">
    <div class="paymentCard paymentCard-wallet">
      <div class="paymentCard-head">
        <app-skeleton className="h-22 w-72% r-6 c-post"></app-skeleton>
        <app-skeleton className="h-18 w-55% r-4 c-post" extraClassName="mt-2"></app-skeleton>
      </div>
      <div class="paymentCard-walletbody mt-4 d-flex align-items-center gap-3">
        <app-skeleton className="h-20 w-20 r-4 c-post"></app-skeleton>
        <app-skeleton className="h-18 w-70% r-4 c-post"></app-skeleton>
      </div>
    </div>
  </div>

  <div class="payment-tabs saved-card mt-3">
    <div class="paymentCard-head d-inline-flex w-100 align-items-center mb-2">
      <app-skeleton className="h-22 w-180 r-6 c-post"></app-skeleton>
    </div>
    <div class="paymentCard-saved">
      <div class="paymentCard-saved-row">
        <div class="order-payment-skeleton__card-inner">
          <div class="flex-grow-1" style="min-width: 0">
            <app-skeleton className="h-20 w-85% r-4 c-post"></app-skeleton>
            <app-skeleton className="h-18 w-40% r-4 c-post" extraClassName="mt-3"></app-skeleton>
            <app-skeleton className="h-24 w-56 r-8 c-post" extraClassName="mt-4"></app-skeleton>
          </div>
          <div class="d-none d-lg-flex flex-column align-items-end gap-2">
            <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
            <app-skeleton className="h-18 w-88 r-4 c-post"></app-skeleton>
          </div>
        </div>
        <div class="d-lg-none mt-3">
          <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
          <app-skeleton className="h-18 w-88 r-4 c-post" extraClassName="mt-2"></app-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="form-group pt-3 d-none d-lg-block">
    <app-skeleton
      className="h-52 w-100% r-32 c-bgt"
      extraClassName="order-payment-skeleton__pay-btn"
    ></app-skeleton>
  </div>
</ng-container>

<ng-template #fullPageSkeleton>
  <div class="row payment-container px-lg-0">
    <div [ngClass]="{ 'col-12 col-lg-7': !isModalView, 'col-12 mt-3': isModalView }">
      <div class="payment-section w-100">
        <div class="paymentCard">
          <div class="order-payment-skeleton__steps">
            <div class="d-flex align-items-center gap-2 flex-grow-1" style="min-width: 0">
              <app-skeleton className="h-18 w-18 r-50% c-post"></app-skeleton>
              <app-skeleton className="h-16 w-65% r-4 c-post"></app-skeleton>
            </div>
            <div class="d-flex align-items-center gap-2">
              <app-skeleton className="h-18 w-18 r-50% c-post"></app-skeleton>
              <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
            </div>
          </div>

          <div class="payment-wallet order-payment-com-page">
            <div class="paymentCard paymentCard-wallet">
              <div class="paymentCard-head">
                <app-skeleton className="h-22 w-72% r-6 c-post"></app-skeleton>
                <app-skeleton className="h-18 w-55% r-4 c-post" extraClassName="mt-2"></app-skeleton>
              </div>
              <div class="paymentCard-walletbody mt-4 d-flex align-items-center gap-3">
                <app-skeleton className="h-20 w-20 r-4 c-post"></app-skeleton>
                <app-skeleton className="h-18 w-70% r-4 c-post"></app-skeleton>
              </div>
            </div>
          </div>

          <div class="payment-tabs saved-card mt-3">
            <div class="paymentCard-head d-inline-flex w-100 align-items-center mb-2">
              <app-skeleton className="h-22 w-180 r-6 c-post"></app-skeleton>
            </div>
            <div class="paymentCard-saved">
              <div class="paymentCard-saved-row">
                <div class="order-payment-skeleton__card-inner">
                  <div class="flex-grow-1" style="min-width: 0">
                    <app-skeleton className="h-20 w-85% r-4 c-post"></app-skeleton>
                    <app-skeleton className="h-18 w-40% r-4 c-post" extraClassName="mt-3"></app-skeleton>
                    <app-skeleton className="h-24 w-56 r-8 c-post" extraClassName="mt-4"></app-skeleton>
                  </div>
                  <div class="d-none d-lg-flex flex-column align-items-end gap-2">
                    <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
                    <app-skeleton className="h-18 w-88 r-4 c-post"></app-skeleton>
                  </div>
                </div>
                <div class="d-lg-none mt-3">
                  <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
                  <app-skeleton className="h-18 w-88 r-4 c-post" extraClassName="mt-2"></app-skeleton>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group pt-3 d-none d-lg-block">
            <app-skeleton
              className="h-52 w-100% r-32 c-bgt"
              extraClassName="order-payment-skeleton__pay-btn"
            ></app-skeleton>
          </div>
        </div>
      </div>
    </div>

    <div
      [ngClass]="{
        'col-12 col-lg-5': !isModalView,
        'col-12 exp-order-1': isModalView,
        'exp-order-mobile-1': isMobileModalView
      }"
    >
      <div class="payment-section order-section">
        <div class="paymentCard">
          <div class="main-subtitle details-subtitle-hint-cl d-flex align-items-center gap-2 mb-3">
            <app-skeleton className="h-18 w-160 r-4 c-post"></app-skeleton>
            <app-skeleton className="h-20 w-20 r-50% c-post"></app-skeleton>
          </div>

          <div class="order-row d-flex flex-column flex-lg-row gap-3">
            <div class="flex-shrink-0">
              <app-skeleton className="h-80 w-80 r-12 c-post"></app-skeleton>
            </div>
            <div class="order-info flex-grow-1" style="min-width: 0">
              <app-skeleton className="h-20 w-100% r-4 c-post"></app-skeleton>
              <app-skeleton className="h-18 w-90% r-4 c-post" extraClassName="mt-2"></app-skeleton>
              <app-skeleton className="h-18 w-70% r-4 c-post" extraClassName="mt-2"></app-skeleton>
              <div class="mt-3 d-flex align-items-center gap-2">
                <app-skeleton className="h-16 w-16 r-50% c-post"></app-skeleton>
                <app-skeleton className="h-14 w-75% r-4 c-post"></app-skeleton>
              </div>
              <div class="mt-2 d-flex align-items-center gap-2">
                <app-skeleton className="h-16 w-16 r-50% c-post"></app-skeleton>
                <app-skeleton className="h-14 w-60% r-4 c-post"></app-skeleton>
              </div>
            </div>
          </div>

          <div class="mt-4">
            <div class="order-item w-100 d-flex">
              <div class="order-col">
                <app-skeleton className="h-16 w-80 r-4 c-post"></app-skeleton>
              </div>
              <div class="order-col text-end">
                <app-skeleton className="h-16 w-56 r-4 c-post ms-auto"></app-skeleton>
              </div>
            </div>
            <div class="order-border-top w-100 my-2"></div>
            <div class="order-item w-100 d-flex">
              <div class="order-col">
                <app-skeleton className="h-16 w-72 r-4 c-post"></app-skeleton>
              </div>
              <div class="order-col text-end">
                <app-skeleton className="h-16 w-24 r-4 c-post ms-auto"></app-skeleton>
              </div>
            </div>
            <div class="order-border-top w-100 my-2"></div>
            <div class="order-item w-100 d-flex">
              <div class="order-col">
                <app-skeleton className="h-18 w-100 r-4 c-post"></app-skeleton>
              </div>
              <div class="order-col text-end">
                <app-skeleton className="h-18 w-64 r-4 c-post ms-auto"></app-skeleton>
              </div>
            </div>
            <div class="order-border-top w-100 my-2"></div>
            <div class="order-item w-100 d-flex align-items-start">
              <div class="order-col">
                <app-skeleton className="h-18 w-120 r-4 c-post"></app-skeleton>
                <app-skeleton className="h-16 w-100 r-4 c-post" extraClassName="mt-2"></app-skeleton>
              </div>
              <div class="order-col text-end">
                <app-skeleton className="h-18 w-64 r-4 c-post ms-auto"></app-skeleton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
